module.exports = __webpack_public_path__ + "static/media/fwbz3.431f101f.png";